import { render, staticRenderFns } from "./widget-config.vue?vue&type=template&id=67c0be61&"
import script from "./widget-config.vue?vue&type=script&lang=js&"
export * from "./widget-config.vue?vue&type=script&lang=js&"
import style0 from "./widget-config.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports